import api from './api';

export type SlowRequestItem = {
  ts: number;
  durationMs: number;
  method: string;
  url: string;
  statusCode: number;
  ip: string;
  userId: number | null;
};

export type SlowRequestTopUrl = {
  url: string;
  count: number;
  maxMs: number;
  p50: number;
  p90: number;
};

export type SlowRequestsResponse = {
  minutes: number;
  minDurationMs: number;
  file: string;
  recent: SlowRequestItem[];
  topUrls: SlowRequestTopUrl[];
};

export type SlowSqlItem = {
  ts: number;
  durationMs: number;
  query: string;
  paramsCount: number;
};

export type SlowSqlTopQuery = {
  query: string;
  count: number;
  maxMs: number;
};

export type SlowSqlResponse = {
  minutes: number;
  minDurationMs: number;
  file: string;
  recent: SlowSqlItem[];
  topQueries: SlowSqlTopQuery[];
};

export async function getSlowRequests(params?: {
  minutes?: number;
  limit?: number;
  minDurationMs?: number;
}) {
  const res = await api.get<SlowRequestsResponse>('/admin/perf/slow-requests', { params });
  return res.data;
}

export async function getSlowSql(params?: {
  minutes?: number;
  limit?: number;
  minDurationMs?: number;
}) {
  const res = await api.get<SlowSqlResponse>('/admin/perf/slow-sql', { params });
  return res.data;
}

